import Grid from "@mui/material/Grid";
import { FaCalendarDay, FaRegFolder, FaRegIdBadge } from "react-icons/fa";
import { Box, Divider, Typography } from "@mui/material";
import { UseFormWatch } from "react-hook-form";

import colors from "../../../../styles/colors/colors";
import fontWeight from "../../../../styles/mui/fontWeight";
import {
  displayFlex,
  flexAlignCentre,
} from "../../../../styles/mui/styles/display";
import {
  PatientDetailsContainer,
  PatientDetailsDivider,
} from "../../../styles/styles";
import { getValue } from "../../../../utils";
import { DateFormats } from "../../../../constants/Date";
import { formatDate } from "../../../../utils/DateTime";
import { EligibilityInformation } from "../../../../models/CheckEligibility";

export interface PropsFromState {
  watch: UseFormWatch<any>;
  eligibilityData: EligibilityInformation | null;
}
type AllProps = PropsFromState;

const PatientHeader: React.FC<any> = ({ watch }: AllProps) => {
  const fieldRender = (label: string, value: string | number | null) => {
    return (
      <Grid sx={{ padding: "0rem 0.5rem " }}>
        <Typography
          variant="body1"
          fontWeight={fontWeight.Weight[3]}
          color={colors.fonts[2]}
        >
          {label}
        </Typography>
        <Box sx={displayFlex}>
          <Typography
            variant="subtitle2"
            fontWeight={fontWeight.Weight[5]}
            color={colors.fonts[4]}
            sx={{ paddingTop: "0.3rem" }}
          >
            {value}
          </Typography>
        </Box>
      </Grid>
    );
  };
  const watchedFields = watch([
    "patientDetail.firstName",
    "patientDetail.lastName",
    "patientDetail.dateOfBirth",
    "patientDetail.eligibilityPayerName",
    "patientDetail.subscriberId",
  ]);

  return (
    <Grid container sx={PatientDetailsContainer}>
      <Grid size={"auto"} pl={"1.5rem"}>
        <Typography
          variant="h2"
          fontWeight={fontWeight.Weight[7]}
          lineHeight={"1.8rem"}
          color={colors.fonts[18]}
        >
          {getValue(watchedFields, "[0]")}&nbsp;
          {getValue(watchedFields, "[1]")}
        </Typography>
      </Grid>
      <Grid size={"auto"}>
        <Divider orientation="vertical" flexItem sx={PatientDetailsDivider} />
      </Grid>
      <Grid size={"auto"} sx={flexAlignCentre}>
        <Box>
          <FaCalendarDay fill={colors.borders[2]} size={"1.2rem"} />
        </Box>
        {fieldRender(
          "DOB",
          formatDate(getValue(watchedFields, "[2]"), DateFormats.MM_DD_YYYY)
        )}
      </Grid>
      <Grid size={"auto"} sx={flexAlignCentre}>
        <Box>
          <FaRegIdBadge fill={colors.borders[2]} size={"1.3rem"} />
        </Box>
        {fieldRender("Subscriber ID", getValue(watchedFields, "[4]"))}
      </Grid>
      <Grid size={"auto"} sx={flexAlignCentre}>
        <Box>
          <FaRegFolder fill={colors.borders[2]} size={"1.5rem"} />
        </Box>
        {fieldRender("Health Plan", getValue(watchedFields, "[3]"))}
      </Grid>
    </Grid>
  );
};

export default PatientHeader;
